import React, { FC, useEffect } from 'react';
import { MuiThemeProvider, createTheme, StylesProvider } from '@material-ui/core/styles';
// import Chip from '@material-ui/core/Chip';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Route } from 'react-router';
import { Switch, BrowserRouter as Router, } from 'react-router-dom';

import PackageView from './pages/PackageView';
import { theme } from './fe_common/client/app/theme';

import './App.css';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const App: FC = () => {

  useEffect(() => {

    const resizeObserver = new ResizeObserver((entries) => {
      let message = {
        height: entries?.[0]?.contentRect?.height,
        width: entries?.[0]?.contentRect?.width,
        type: 'iframepocscrollmsg',
      };
      // window.top refers to parent window
      window.top.postMessage(message, '*');
    });

    resizeObserver.observe(document.body);
  }, []);

  // @ts-ignore
  const muiThemeV4 = createTheme(theme);

  return (
    <StylesProvider injectFirst>
      <MuiThemeProvider theme={muiThemeV4}>
        <>
          <CssBaseline />
          <Router>
            <Switch>
              {/*<Route path="/302750235" exact component={Chip} />*/}
              <Route path="*" component={PackageView} />
            </Switch>
          </Router>
        </>
      </MuiThemeProvider>
    </StylesProvider>
  );

};

export default App;
